<template>
    <div class="">

        <VMap style="height: 600px;" :center="mapCenter" :zoom="mapZoom">
            <VMapOsmTileLayer attribution="Open Street Map"/>
            <VMapZoomControl/>
            <VMapAttributionControl/>
            <VMapPinMarker v-for="pin in pins" @click="centerMapOnPin(pin)" :latlng="[pin.lat, pin.lng]">
                <VMapPinIcon>
                <svg
                    data-name="Group 138"
                    width="24"
                    height="36"
                    viewBox="0 0 66.665001 99.896097"
                    version="1.1"
                    id="svg13"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:svg="http://www.w3.org/2000/svg">
                    <defs
                        id="defs5">
                        <clipPath
                            id="jvp825l7ea">
                            <path
                                data-name="Rectangle 79"
                                style="fill:#003087"
                                d="M 0,0 H 66.665 V 99.9 H 0 Z"
                                id="path2"/>
                        </clipPath>
                    </defs>
                    <g
                        data-name="Group 137"
                        clip-path="url(#jvp825l7ea)"
                        id="g11"
                        transform="translate(0,-0.00390625)">
                        <path
                            id="path7"
                            style="fill:#003087"
                            d="M 33.332031,0.00390625 C 6.856163,0.00390625 -9.0509736,29.383574 5.421875,51.554688 L 33.332031,99.900391 61.244141,51.554688 C 75.716989,29.383574 59.8079,0.00390625 33.332031,0.00390625 Z M 32.921875,21.5 c 6.592094,-0.166723 13.013059,4.902503 13.013672,12.625 -0.0077,6.95672 -5.642894,12.595851 -12.599609,12.607422 C 22.103217,46.737768 16.474498,33.15882 24.414062,25.214844 26.895177,22.732352 29.925469,21.575783 32.921875,21.5 Z"/>
                    </g>
                </svg>
                </VMapPinIcon>
                    <address class="map-pin">
                        <strong>{{ pin.title }}</strong><br>{{ pin.address }}<br>{{ pin.suburb }} <br> {{pin.state }}
                        {{ pin.postcode }}
                    </address>

            </VMapPinMarker>
        </VMap>
        <div class="reset-button"><span class="bg-white" @click="resetMap">Reset map</span></div>
    </div>
</template>


<script>
import {defineComponent} from 'vue'
import {VMap, VMapOsmTileLayer, VMapZoomControl, VMapAttributionControl, VMapPinMarker, VMapDefaultIcon} from 'vue-map-ui';

import 'leaflet/dist/leaflet.css';
import 'vue-map-ui/dist/normalize.css';
import 'vue-map-ui/dist/style.css';
import 'vue-map-ui/dist/theme-all.css';
import gql from "graphql-tag";
export default {
    name: "MapBox",
    data: {
        mapCenterInitial: [0,0],
        mapZoomInitial: 12,
        mapCenter: [0,0],
        mapZoom: 12,
        elementID: 0
    },
    props: {
        center: {
            type: String,
            default: []
        },
        zoom: {
            type: Number,
            default: 1
        },
        element_id: {
            type: Number,
            default: 0
        }
    },
    computed: {
        pins: function () {
            return (this.readPins && this.readPins.hasOwnProperty('nodes')) ? this.readPins.nodes : {};
        }
    },
    methods: {
        centerMapOnPin: function (pin) {
            this.mapCenter = [pin.lat, pin.lng];
            this.mapZoom = 18;
        },
        resetMap: function () {
            this.mapCenter = this.mapCenterInitial;
            this.mapZoom = this.mapZoomInitial;
        }
    },
    mounted() {
        this.mapCenter = JSON.parse(this.center);
        this.mapZoom = parseInt(JSON.parse(this.zoom));
        this.mapCenterInitial = JSON.parse(this.center);
        this.mapZoomInitial = parseInt(JSON.parse(this.zoom));
        this.elementID = parseInt(JSON.parse(this.element_id));
    },
    components: {
        VMap,
        VMapOsmTileLayer,
        VMapZoomControl,
        VMapAttributionControl,
        VMapPinMarker,
        VMapDefaultIcon
    },
    apollo: {
        readPins: {
            query: gql`
                query readPins ($elementID: ID) {
                    readPins (filter: {openStreetMapID: {eq: $elementID}}) {
                        nodes
                        {
                            id
                            className
                            lastEdited
                            created
                            latLngOverride
                            lat
                            lng
                            address
                            suburb
                            state
                            postcode
                            country
                            title
                            openStreetMapID
                        }
                    }
                }`,
            variables() {
                return {
                    elementID: this.elementID
                }
            },
            update: function (data) {
                return data.readPins;
            },
            fetchPolicy: 'cache-and-network'
        }
    }
}
</script>




<style scoped>
    .reset-button {
        text-align: center;
    }

    .reset-button span {
        display: inline-block;
        padding: 3px 10px;
        margin-bottom: -1rem;
        cursor: pointer;
    }

    .map-pin {
        margin-top: 1rem;
        background: rgba(255,255,255,0.7);
        width: 10rem;
        padding: 1rem;
        border-radius: 1rem;
        margin-top: -40px;
        margin-left: 40px;
    }
</style>
